<template>
    <div>
  <Navbar />
  <!-- Start Team Area -->
      <section class="team-section pt-100 pb-70">
        <div class="container">
          <div class="team-title-area">
            <div class="row align-items-center">
              <div class="col-lg-7">
                <div class="section-title text-left">
                <span>
                  <i class="flaticon-support"></i>
                  Meet Our Leaders
                </span>
                  <h2>RPC Leadership</h2>
                  <p></p>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
              <div class="team-item">
                <div class="image">
                  <img
                          class="team-img "
                          src="assets/img/thc/thc_leaders1.png"
                          alt="image"
                  />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content" style="height:20rem">
                  <h3>Sholofelo Kgwalabatlhe</h3>
                  <span>Psychologist, THC </span>
                  <span>My name is Tsholofelo Kgwalabatlhe. I accepted Jesus Christ as my personal savior and Lord as a young girl and has since then grown steadily in my faith in the word of God. Educationally, I hold a Bachelor of Arts in Psychology in Helderberg College in Cape town South Africa and a Postgraduate Honours Degree in Psychology at Rhodes University in Grahamstown South Africa. </span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
              <div class="team-item">
                <div class="image">
                  <img
                          class="team-img "
                          src="assets/img/thc/thc_leaders2.png"
                          alt="image"
                  />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content" style="height:20rem">
                  <h3>Masibisibi Leetete</h3>
                  <span>Counsellor, THC</span>
                  <span>Sister Masibisibi Leetete AKA Ndade is an extremely motivated & dedicated young woman who is highly available in the hands of God. Ndade is an epitome of LOYALTY. Her leadership skills and extreme humility can be mistaken for foolishness but she is far from that. She holds a first degree in Pastoral Care and Counselling, a Master degree in Public Policy and Administration. </span>
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
              <div class="team-item">
                <div class="image">
                  <img
                          class="team-img "
                          src="assets/img/thc/thc_leaders3.png"
                          alt="image"
                  />

                  <ul class="social">
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="content" style="height:20rem">
                  <h3>Queen T Masike</h3>
                  <span>Volunteer</span>
                  <span>Queen T. Masike met the man of God, Dr Goodhead, end of July, 2019.
                    Queen testifies that both RPC meetings and the Trauma Healing initiative helped her to heal from all the trauma that she went through and these also helped her to grow spiritually.
                    “My perspective about life has been reshaped and I genuinely look forward to also being a blessing to other people”.
                    Glory be to the Most High God.
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  <!-- End Team Area -->
  <Footer />
    </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "../../Footer";
export default {
  name: "Team",
  components: { Footer, Navbar }
};
</script>

<style scoped>
.team-img {
  height: 300px;
}
</style>
